import { trackEvent } from '../../../utils/analytics';

export default function Hero() {
  const handleCalendarClick = () => {
    trackEvent('calendar_click');
  };

  return (
    <section className="relative flex items-center justify-center overflow-hidden pt-16">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/befe70d7a05bf9ea915c94156181e14a.jpg)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center py-20 sm:py-24 md:py-28">
        <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-white mb-6 tracking-tight leading-none">
          PROTECT WHAT'S MINE
        </h1>
        
        <div className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 mb-4 font-medium leading-relaxed">
          <p className="mb-2">Entity Structuring. Tax Strategy. Estate Planning.</p>
          <p>One attorney. One plan. Total protection.</p>
        </div>

        <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Curated by Matt Theriault. Executed by KKOS Lawyers.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
          <a 
            href="#calendar"
            onClick={handleCalendarClick}
            className="w-full sm:w-auto bg-[#dc2626] hover:bg-[#b91c1c] text-white font-black px-8 py-4 rounded-lg text-base sm:text-lg transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer text-center"
          >
            GET PROTECTED NOW
          </a>
          <a 
            href="#how-it-works"
            className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-lg text-base sm:text-lg transition-all border border-white/30 backdrop-blur-sm whitespace-nowrap cursor-pointer text-center"
          >
            HOW IT WORKS
          </a>
        </div>
      </div>

      {/* Bottom Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0a0a0a] to-transparent"></div>
    </section>
  );
}
